export const PLAY_ICON = '⏵';
export const PAUSE_ICON = '⏸';
export const IS_PLAYING = 'isPlaying';
export const IS_PAUSED = 'isPaused';
